import React, { Component } from 'react';
import * as axios from 'axios';
import './HeroOption1.scss';

class HeroOption1 extends Component {


  constructor(props) {
    super(props);
    this.state = {
		data:{},
		loaded:false
    };
    
  }
  
  componentDidMount() {
	if(this.props.data.ctaId && this.props.data.ctaIndex){
		
		axios({
			method: 'GET',
			url: '/search-api/'+this.props.data.ctaIndex+'/call_to_action/'+this.props.data.ctaId,
			headers: {
			'Content-Type': 'application/json'
			},
	    }).then((response) => {
		    var ctaObject=response.data._source;
			this.props.data.ctaTitle=ctaObject.title;
			
			this.setState({ loaded:true, data:ctaObject});	    })
	    .catch((error) => {

	    });
	   }
	}    
	isVideo() {
		if(this.props.data.videoUrl) {
			return ' video';
		} else {
			return '';
		}
	}

	videoMarkup() {
		if(this.props.data.videoUrl) {
			
			return (
			<div className="video-controls-overlay">
				<button className="play-video" style={{border:'none'}}>
					<span className="icon-play"></span>
					<span className="label-play">Play video</span>
					<p>{this.props.data.videoCaption}</p>
				</button>
			</div>);
		} else {
			return false;
		}
	}
	videoModal(){
		if(this.props.data.videoUrl) {
			var modalStyle={
				display:'none'
			};
			return (
			<div className="video" style={modalStyle}>
				<div className="video-embed-field-responsive-video">
					<span className="close">Close</span>
					<iframe title="modalvideo" width="854" height="480" frameborder="0" allowfullscreen="allowfullscreen" src={this.props.data.videoUrl}></iframe>
				</div>
			</div>);
		} else {
			return false;
		}
	}
	renderCTA(){
		if(this.props.data.ctaId && this.props.data.ctaIndex){
			if(this.state.loaded){
				const button2 = this.state.data.secondary_link_url?(
					<a className="button last" href={this.state.data.secondary_link_url.value}>
					{this.state.data.secondary_link_text.value}
					</a>
				):"";
				const button_override=button2===""?{margin:'auto',float:'none'}:{};
				const button1 = this.state.data.primary_link_url?(
					<a className="button first" href={this.state.data.primary_link_url.value} style={button_override}>
					{this.state.data.primary_link_text.value}
					</a>
				):"";
				
				
				return (
					<div className="cta-block">
						<div className="cta-headline">
							<p>{this.state.data.title}</p>
							{button1}
							{button2}
						</div>
					</div>
				)
			}else{
				return (
				<div className="cta-block">
					<div className="la-ball-grid-pulse">
					    <div></div>
					    <div></div>
					    <div></div>
					    <div></div>
					    <div></div>
					    <div></div>
					    <div></div>
					    <div></div>
					    <div></div>
					</div>
				</div>
				); 
			}
		} else {
			return (
				<div className="cta-block">
					<div className="cta-headline">
						<p>{this.props.data.ctaTitle}</p>
						<a className="button first" href={this.props.data.applyNowLink}>
						Apply Now
						</a>
						<a className="button last" href={this.props.data.requestInfoLink}>
						Request Info
						</a>
					</div>
				</div>
			);
		}
	}
  render() {
    return (
		<div className={'hero-option-1'+this.isVideo()}>
			<div className="wrapper">
				<div className="image-wrapper">
					<div className="image" style={{ backgroundImage: 'url(\''+this.props.data.bannerImage+'\')' }}>
					{this.videoMarkup()}
					</div>
				</div>
			</div>
			<div className="text-block admissions">
				<div className="text-wrapper">
					<h5 className="title">{this.props.data.title}</h5>
					<div className="text-block-content">
					{this.props.data.subtitle}
					</div>
				</div>
			</div>
			{this.renderCTA()}
			{this.videoModal()} 
		</div>
    );
  }
}

export default HeroOption1;








// WEBPACK FOOTER //
// ./src/HeroOption1/HeroOption1.js